import React from 'react';
import './App.css';

import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { AppWalletProvider } from '@cai/shared/wallet';
import { DAppStateProvider } from './context/DAppStateProvider';
import { ConfigProvider } from './context/ConfigProvider';
const App = () => {
  return (
    <ConfigProvider>
      <AppWalletProvider
        appName="CryptoVerseAI Frontend"
        projectId={process.env.REACT_APP_REOWN_PROJECT_ID}
      >
        <DAppStateProvider>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </DAppStateProvider>
      </AppWalletProvider>
    </ConfigProvider>
  );
};
export default App;
